import React, { useState, useEffect, Fragment, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl'
import moment from 'moment';


//Helpers
import { statusPill, getMaintenanceBar } from '../../../../.globals/helpers';

//Hooks
import { usePaggination } from '../../../../../../core/hooks';

//Components
import {
    TableView,
    Link,
    IconButton,
    SearchInput,
    TableButtons,
    MenuComponent,
} from '@gpstrackit/gtc-react-controls';
import { NotificationManager } from 'Components/Notifications';
import { FormattedNumber } from 'react-intl';
import { Grid } from '@mui/material';

//Views
import ManageDriverTasksScheduled from '../../../../modals/manageDriverTasksScheduled';
import CompleteDriverScheduledTask from '../../../../modals/completeDriverScheduledTask';
import DeleteDriverScheduledTask from '../../../../modals/deleteDriverScheduledTask';
import ScheduleDriverTask from '../../../../modals/scheduleDriverTask';
import EntityDetails from '../../../../modals/entityDetails';
import ManageTasks from '../../../../modals/manageTasks';

//Actions
import {
    openModalDeleteDriverScheduledTaskRedux,
    openModalCompleteDriverScheduledTask,
    openModalManageDriverTasksScheduled,
    openModalScheduleDriverTasks,
    openModalEntityDetails,
    openModalManageTasks,
    sendGenericExport,
    clearRedux,
} from 'Redux/actions';

import {
    maintenanceVDTSearchDrivers,
    reset,
} from './redux/slice';
const DriversTab = (props) => {
    const { messages, locale } = useIntl();
    const tableRef = useRef();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const {
        loadingListDriverScheduledTasks,
        listDriverScheduledTasks,
        loading,
        items,
        total,
    } = useSelector(state => state.maintenanceDriversTabRedux);
    const openCompleteDriverScheduledTask = useSelector(state => state.maintenanceCompleteDriverScheduledTaskRedux.open);
    const openManageDriverTasksScheduled = useSelector(state => state.maintenanceManageDriverTasksScheduledRedux.open);
    const openDeleteDriverScheduledTask = useSelector(state => state.maintenanceDeleteDriverScheduledTaskRedux.open);
    const openScheduleDriverTasks = useSelector(state => state.maintenanceScheduleDriverTasksRedux.open);
    const openEntityDetails = useSelector(state => state.maintenanceEntityDetailsRedux.open);
    const openManageTasks = useSelector(state => state.maintenanceManageTasksRedux.open);
    const exportResult = useSelector(state => state.commomRedux.exportResult);
    const exportName = useSelector(state => state.commomRedux.exportName);

    const menuDriverTasksOptions = [
        messages['driversTasksTab_edit'],
        messages['driversTasksTab_complete'],
        messages['driversTasksTab_delete'],
    ];

    const paggination = usePaggination(maintenanceVDTSearchDrivers, ["title"], null, null,[{
        "fields": ["status"],
        "terms": [1]
    }])



    const { loadingDrivers } = props;
    const [driverScheduledTasks, setDriverScheduledTasks] = useState([]);
    const [selectedItems, setSelectedItems] = useState([])

    const handleDetails = (entityId, entityName, numberTab, title) => {
        dispatch(openModalEntityDetails({ open: true, entityId, entityName, numberTab, title }))
    };

    useEffect(() => {
        paggination.refresh()
        return () => {
            dispatch(reset())
        }
    }, []);

    useEffect(() => {
        if (loading) setDriverScheduledTasks([]);
    }, [loading])

    useEffect(() => {
        if (listDriverScheduledTasks && listDriverScheduledTasks.length > 0) {
            let data = []
            listDriverScheduledTasks.forEach(element => {
                let scheduledTasks = driverScheduledTasks.some((t) => t.id === element.id);
                if (!scheduledTasks) data.push(element);
            });
            setDriverScheduledTasks([...driverScheduledTasks, ...data]);
        }
    }, [listDriverScheduledTasks])

    useEffect(() => {
        paggination.setColumns([
            {
                key: 'title',
                title: messages['driversTasksTab_Regarding'],
                show: true,
                export: true,
                width: 200,
                sort: true,
                render: (row) => {
                    return (
                        <Grid container alignItems="center">
                            <Grid item sm={9} style={{ width: 200 }}>
                                <Link
                                    className="table-span"
                                    dest={`/app/maintenance/driverDetail/${row.id}`}
                                    onClick={() => navigate(`/app/maintenance/driverDetail/${row.id}`)}
                                    text={row.title}
                                />
                            </Grid>
                            <Grid item sm={3}>
                                <IconButton
                                    disabled={loading || loadingDrivers}
                                    aria-haspopup="true"
                                    variant="contained"
                                    onClick={() => dispatch(openModalManageDriverTasksScheduled({ open: true, driverId: row.driverId, driverName: row.title }))}
                                    placement="bottom"
                                    icon="edit"
                                    className="showInHover"
                                    size="small"
                                />
                            </Grid>
                        </Grid>
                    )
                },
                functionString: `
                    let title = row?.title || ""
                    if (title.length > 30) {
                        title = title.slice(0, 30) + "...";
                    }
                    return title
                `
            },
            {
                key: 'driverScheduledTasksCount',
                title: messages['driversTasksTab_task'],
                show: true,
                export: true,
                width: 150,
                render: (row) => {
                    let tasksLabel = "";
                    if (row.driverScheduledTasksCount > 1) tasksLabel = `${row.driverScheduledTasksCount} ${messages['driversTasksTab_labelTasks']}`
                    else tasksLabel = row.nextDriverScheduledTask ? row.nextDriverScheduledTask.driverTaskName : `${row.driverScheduledTasksCount} ${messages['driversTasksTab_labelTasks']}`
                    return (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <div>
                                <span>{tasksLabel}</span>
                            </div>
                            <div>
                                {row.driverScheduledTasksCount === 1 &&
                                    row.nextDriverScheduledTask?.status != "Done" && (
                                        //TO DO add validation when the task is completed
                                        <MenuComponent
                                            className="showInHover"
                                            isDisable={loadingListDriverScheduledTasks}
                                            options={menuDriverTasksOptions}
                                            onClick={(type, value) => {
                                                const newValueTask = value.nextDriverScheduledTask;
                                                if (newValueTask) {
                                                    if (type === messages["edit"]) {
                                                        dispatch(openModalScheduleDriverTasks({ open: true, id: row.nextDriverScheduledTask.id }))
                                                    } else if (type === messages["complete"]) {
                                                        dispatch(openModalCompleteDriverScheduledTask({ open: true, tasks: row.nextDriverScheduledTask, driverName: row.title }))
                                                    } else if (type === messages["delete"]) {
                                                        dispatch(openModalDeleteDriverScheduledTaskRedux({ open: true, tasks: row.nextDriverScheduledTask, driverName: row.title }))
                                                    }
                                                }
                                            }}
                                            value={row}
                                            icon="more_vert"
                                        />
                                    )}
                            </div>
                        </div>
                    )
                },
                functionString: `
                    let lag = "${locale}"
                    let tasksLabel = "";
                    let complement = lag === "en" ? " Tasks" : " Tareas"
                    if(row.driverScheduledTasksCount > 1){
                        tasksLabel = row.driverScheduledTasksCount + complement
                    }else {
                        tasksLabel = row.nextDriverScheduledTask ? row.nextDriverScheduledTask.driverTaskName : row.driverScheduledTasksCount + complement
                    }
                    return tasksLabel
                `
            },
            {
                key: 'dueDate',
                title: messages['driversTasksTab_due'],
                show: true,
                export: true,
                render: (row) => {
                    if (row.nextDriverScheduledTask) {
                        return (
                            <>
                                {getMaintenanceBar(
                                    "time",
                                    row.nextDriverScheduledTask.status,
                                    row.nextDriverScheduledTask.lastMaintenanceDate ||
                                    row.nextDriverScheduledTask.createdOn,
                                    row.nextDriverScheduledTask.dueDate,
                                    moment(),
                                    messages
                                )}
                            </>
                        );
                    }
                },
                functionString: `return row?.nextDriverScheduledTask?.lastMaintenanceDate`
            },
            {
                key: 'estimatedCost',
                title: messages['driversTasksTab_cost'],
                show: true,
                export: true,
                render: (row) => {
                    if (row.nextDriverScheduledTask) {
                        const { estimatedCost } = row.nextDriverScheduledTask;
                        return (
                            estimatedCost && (
                                <FormattedNumber
                                    value={estimatedCost}
                                    style="currency"
                                    currency="USD"
                                />
                            )
                        );
                    }
                },
                functionString: `
                    const format = { style: 'currency', currency: 'USD' };
                    const numberFormat = new Intl.NumberFormat('en-US', format);
                    return row.nextDriverScheduledTask?.estimatedCost ? numberFormat.format(row.nextDriverScheduledTask?.estimatedCost) : '';
                `
            },
            {
                key: 'status',
                title: messages['driversTasksTab_status'],
                show: true,
                export: true,
                render: (row) => {
                    if (row.nextDriverScheduledTask) {
                        return <>{statusPill(row.nextDriverScheduledTask)}</>;
                    }
                },
                functionString: `
                    let lag = "${locale}"
                    let status = row.nextDriverScheduledTask.status
                    if(lag === "es"){
                        if(status === "Scheduled") {
                            status = "Programado"
                        }
                        if(status === "PastDue") {
                            status = "Atrasado"
                        }
                        if(status === "DueSoon") {
                            status = "Prox a Vencer"
                        }
                        if(status === "DueNow") {
                            status = "Vencido"
                        }
                        if(status === "Done") {
                            status = "Terminado"
                        }
                    }
                    return status
                `
            },
            {
                key: 'subscribers',
                title: messages['driversTasksTab_subscribers'],
                show: true,
                export: true,
                render: (row) => {
                    if (row.nextDriverScheduledTask) {
                        const { subscribersCount, id, driverTaskName } = row.nextDriverScheduledTask;
                        return (
                            <>
                                {subscribersCount > 0 && (
                                    <IconButton
                                        placement="bottom"
                                        variant="secondary"
                                        icon="people"
                                        size="small"
                                        disabled={loading}
                                        onClick={() => { handleDetails(id, 'DriverScheduledTask', 0, driverTaskName, row) }}
                                    />
                                )}
                            </>
                        );
                    }
                },
                functionString: `return row?.nextDriverScheduledTask?.subscribersCount || ""`
            },
            {
                key: 'notes',
                title: messages['driversTasksTab_notes'],
                show: true,
                export: true,
                render: (row) => {
                    if (row.nextDriverScheduledTask) {
                        const { notes, id, driverTaskName } = row.nextDriverScheduledTask;
                        return (
                            <>
                                {notes ? (
                                    <IconButton
                                        placement="bottom"
                                        variant="secondary"
                                        icon="comment"
                                        size="small"
                                        disabled={loading}
                                        onClick={() => { handleDetails(id, 'DriverScheduledTask', 1, driverTaskName, row) }}
                                    />
                                ) : (
                                    ""
                                )}
                            </>
                        );
                    }
                },
                functionString: `return row?.nextDriverScheduledTask?.notes || ""`
            },
            {
                key: 'attachments',
                title: messages['driversTasksTab_attachments'],
                show: true,
                export: true,
                render: (row) => {
                    if (row.nextDriverScheduledTask) {
                        const { fileIds, id, driverTaskName } = row.nextDriverScheduledTask;
                        return (
                            <>
                                {fileIds && fileIds.length > 0 && (
                                    <IconButton
                                        placement="bottom"
                                        variant="secondary"
                                        icon="attach_file"
                                        size="small"
                                        disabled={loading}
                                        onClick={() => { handleDetails(id, 'DriverScheduledTask', 2, driverTaskName, row) }}
                                    />
                                )}
                            </>
                        );
                    }
                },
                functionString: `return row?.nextDriverScheduledTask?.fileIds?.length || ""`
            },
        ]);
    }, [locale]);

    useEffect(() => {
        if (exportResult && exportName === "drivers_list") {
            NotificationManager.info(
                messages['exportInProcessBody'],
                messages['exportInProcessTitle'],
                4000,
                null,
                null,
                'info',
                null
            );
            dispatch(clearRedux("COMMON", { exportResult: null, exportName: null }));
        }
    }, [exportResult, exportName]);

    const refreshTable = () => {
        tableRef?.current?.setSelectedItems([]);
        paggination.refresh();
    }

    return (
        <Fragment>
            <Grid container direction="row" justifyContent="space-between" alignItems="center">
                <Grid item xs={6} sm={2}>
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={1}
                    >
                        <Grid item style={{ display: 'flex' }}>
                            <IconButton
                                tooltip={messages["add"]}
                                placement="bottom"
                                variant="secondary"
                                icon="add_box"
                                size="small"
                                disabled={loading}
                                onClick={() => dispatch(openModalScheduleDriverTasks({ open: true }))}
                            />
                            <IconButton
                                tooltip={messages["driversTasksTab_Manage_tasks"]}
                                placement="bottom"
                                variant="secondary"
                                icon="assignment"
                                size="small"
                                disabled={loading}
                                onClick={() => dispatch(openModalManageTasks({ open: true }))}
                            />
                            <TableButtons
                                messages={messages}
                                tableRef={tableRef}
                                buttons={['export']}
                                onExport={(type) => {
                                    let currentConditions = paggination.currentConditions;
                                    let currentSort = paggination.currentSort;
                                    const columns = paggination?.columns
                                    const headers = columns.filter(x => x.show && x.export).map(x => { return { header: x.title, column: x.key, functionString: x.functionString } }) || [];
                                    const columnStyles = {6: {cellWidth: 140}}
                                    dispatch(sendGenericExport(
                                        "drivers_list",
                                        type,
                                        `
                                            query searchDrivers ($conditions: [DriverSearchInput], $sort: [DriverSortInput], $limit: Int, $offset: Int) {
                                                data: searchDrivers (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                                                    items {
                                                        id
                                                        title
                                                        driverId
                                                        companyId
                                                        driverScheduledTasksCount
                                                        nextDriverScheduledTask {
                                                            id
                                                            driverId
                                                            driverTaskId
                                                            driverTaskName
                                                            estimatedCost
                                                            notes
                                                            completed
                                                            dueDate
                                                            frequency
                                                            fileIds
                                                            status
                                                            lastMaintenanceDate
                                                            createdOn
                                                            files {
                                                            id
                                                            fileKey
                                                            }
                                                            subscribersCount
                                                        }
                                                    }
                                                    total
                                                }
                                            }
                                        `,
                                        {
                                            conditions: currentConditions,
                                            sort: currentSort,
                                            limit: 10,
                                            offset: 0
                                        },
                                        headers,
                                        { unit: 'px', size: 'A4', orientation: 'landscape', fontSize: 10 },
                                        null,
                                        null,
                                        true,
                                        columnStyles
                                    ));
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={4} className="mb-10 text-right">
                    <SearchInput
                        placeholder={messages['search']}
                        searchText={paggination.searchText}
                        onSearchText={paggination.onSearchChange}
                    />
                </Grid>
            </Grid>
            <TableView
                ref={tableRef}
                keyColumn="id"
                data={items || []}
                total={total || 0}
                loading={loading}
                hideAllInPagination
                topheight={250}
                hideDragable
                onSelectedItems={(items) => setSelectedItems(items)}
                disableItemSelection
                {...paggination}
            />
            {openScheduleDriverTasks && <ScheduleDriverTask refresh={() => refreshTable()} />}
            {openCompleteDriverScheduledTask && <CompleteDriverScheduledTask refresh={() => refreshTable()} />}
            {openManageDriverTasksScheduled && <ManageDriverTasksScheduled />}
            {openDeleteDriverScheduledTask && <DeleteDriverScheduledTask refresh={() => refreshTable()} />}
            {openEntityDetails && <EntityDetails refresh={() => refreshTable()} />}
            {openManageTasks && <ManageTasks />}
        </Fragment>
    );
};

export default DriversTab
